import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalSettingsStores from '../../../../stores/settings-stores';

export const updatePollNameOperation = async (
  pollId: number,
  pollName: string,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (pollName.length < 2 || pollName.length > 100) {
      toast.warn('על שם המשוב להיות בין 2 ל100 תווים');
      return;
    }
    setLoading(true);
    await appApi.updateAbstractPollName(pollId, pollName);
    await globalSettingsStores.fetchSetting();
    toast.success('שם המשוב עודכן בהצלחה');
    setLoading(false);
    closeDialog();
  } catch (e) {
    toast.error('לא ניתן לבצע את הפעולה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
